import { useCallback, useRef, useState } from 'react';
var useDragAndDrop = function (handleDrop) {
    var _a = useState(false), isDragging = _a[0], setIsDragging = _a[1];
    var dragCounterRef = useRef();
    var onDragOver = useCallback(function (event) {
        event.preventDefault();
        event.stopPropagation();
    }, []);
    var onDragEnter = useCallback(function (event) {
        var _a;
        event.preventDefault();
        event.stopPropagation();
        dragCounterRef.current++;
        if (((_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.items) && event.dataTransfer.items.length > 0)
            setIsDragging(true);
    }, []);
    var onDragLeave = useCallback(function (event) {
        event.preventDefault();
        event.stopPropagation();
        dragCounterRef.current--;
        if (dragCounterRef.current === 0)
            setIsDragging(false);
    }, []);
    var onDrop = useCallback(function (event) {
        var _a;
        event.preventDefault();
        event.stopPropagation();
        setIsDragging(false);
        if (((_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.files) && event.dataTransfer.files.length > 0) {
            handleDrop(event.dataTransfer.files);
            event.dataTransfer.clearData();
            dragCounterRef.current = 0;
        }
    }, [handleDrop]);
    return { isDragging: isDragging, onDragOver: onDragOver, onDragEnter: onDragEnter, onDragLeave: onDragLeave, onDrop: onDrop };
};
export default useDragAndDrop;
//# sourceMappingURL=useDragAndDrop.js.map